import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(!_vm.isLoginPage)?_c('AppNavigation'):_vm._e(),_c(VMain,[_c('router-view')],1),(!_vm.isLoginPage)?_c('AppFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }